module.exports = {
  insuranceLead: [
    "Advertisement",
    "Cold Call",
    "Employee Referral",
    "External Referral",
    "Online Store",
    "Partner",
    "Public Relations",
    "Sales Email Alias",
    "Seminar Partner",
    "Internal Seminar",
    "Trade Show",
    "Web Download",
    "chat",
  ],
  dealOwnerOptions: ["Existing Business", "New Business"],
  stage: [
    "Qualification",
    "Needs Analysis",
    "Value Proposition",
    "Identify Decision Makers",
    "Presentation",
    "Application",
    "Signature",
    "Underwriting",
    "Medical",
    "APS/ MIB",
    "Decision ( Approved/Denial/ PostPone/Rated)",
    "Accepted / Re-Apply/ Change Premium",
    "Delivery",
    "Convert Life",
  ],
  forecastCategory: ["Pipeline", "Best Case", "Committed"],
  type: ["Existing Business", "New Business"],
  currency: ["CAD", "USD"],
  objectType: ["-None-", "Yes", "No"],
  noList: ["-None-", "Yes Upto 4", "More than 4 to 6"],
  medicalNeeds: ["-None-", "Required", "Not required"],
  rating: ["-None-", "Approved with Rating", "Approved without Rating"],
  renewal: ["-None-", "Unknown", "Required", "Not Required"],
  claims: ["-None-", "Yes", "No", "Unkown"],
  approval: ["-None-", "Approved", "Rejected"],
  relationShipStatusOptions: [
    "-None-",
    "Single",
    "Married",
    "Divorced",
    "Common Law",
    "Widow",
    "Widower",
  ],
  choice: ["-None-", "Unknown", "Yes", "No"],
  dependentParentsOption: ["Mother", "Father", "Mother in Law", "Father in Law"],
  dependentChildrenOption: ["Son", "Daughter", "Step Son", "Step Daughter"],
  religionOptions: [
    "-None-",
    "Buddhism",
    "Unknown",
    "Christianity",
    "Hinduism",
    "Islam",
    "Judaism",
    "Sikhism",
  ],
  festivalsOptions: [
    "Eid-ul-Fitr",
    "Bakr-Eid",
    "Holi",
    "Dussehra",
    "Diwali",
    "Raksha Bandhan",
    "Guru Nanak Jayanti",
    "Guru Gobind Singh Jayanti",
    "Guru Granth Sahib Prakash Divas",
    "Passover",
    "Victoria Day",
    "Family Day",
    "Mother's Day",
    "Thanksgiving",
    "Christmas",
    "New Year",
    "Lohri",
    "Vaisakhi",
    "Father's Day",
  ],
  celebratedFestivalsOptions: [
    "Canada Day",
    "New Year",
    "Family Day",
    "Victoria Day",
    "Father's Day",
    "Mother's Day",
  ],
  arethereMultipleBeneficiariesexclClient:[
    "-None-",
    "Yes - upto 4",
    "More Than 4 to 6"
  ],
  applicationMedicalRequirementOptions:[
    "-None-",
    "Required",
    "Not required"
  ],
 

};
